export const formatMediaUrl = (mediaName?: string | null) => {
  const BASE_IMG = process.env.REACT_APP_IMGIX_URL || "";
  const IMG_URL = BASE_IMG + mediaName;
  return IMG_URL;
};
